<template>
  <div class="ai-message-list">
    <!-- ai列表 -->
    <div class="ai-message-item" v-for="(item, index) in list" :key="index" :class="{right : item.imUserId}">
      <img class="avatar" :src="item.imUserId ? require('../../common/img/yh_avatar.png') : require('../../common/img/ai_robot.png')" alt="">
      <div class="message-outer">
        <div class="message-time">{{ item.createTime }}</div>
        <div class="message-text" v-html="item.answer"  v-imgViewer></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['list'],
  created () {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang='less' scoped>
.ai-message-list{
  .ai-message-item{
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
    &.right{
      flex-direction: row-reverse;
      .message-outer{
        .message-text{
          background-color: #0087FF;
          color: #fff;
          border-radius: 8px 1px 8px 8px;
          box-shadow: none;
        }
      }
    }
    .avatar{
      width: 40px;
      height: 40px;
    }
    .message-outer{
      max-width: 60%;
      .message-time{
        color: #999;
        font-size: 12px;
        margin-bottom: 3px;
      }
      /deep/.message-text{
        padding: 8px 12px;
        background-color: #fff;
        box-shadow: 2px 2px 11px 7px rgba(0, 0, 0, 0.1);
        border-radius: 1px 8px 8px 8px;
        line-height: 24px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        white-space: normal;
        think{
          display: none;
        }
        img{
          cursor: pointer;
        }
        *{
          max-width: 100%!important;
          word-break: break-all!important;
          white-space: pre-wrap!important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/AiMessageList.vue